import {
  getInsightAccentTextClass,
  getInsightCardBgClass,
  InsightSectionProps,
} from "./insightSectionTypes";

/**
 * Insight section with an uppercase heading and per-item colored cards.
 * Danger is reddish; warning is yellowish for Step Therapy Requirement.
 *
 * @param props.title - Uppercase section heading
 * @param props.items - Insight text items to list
 * @param props.variant - Optional color variant
 */
const InsightSection = (props: InsightSectionProps) => {
  const { title, items, variant = "neutral" } = props;
  const isAccented = variant === "danger" || variant === "warning";
  const accentTextClass = getInsightAccentTextClass(variant);
  const cardBgClass = getInsightCardBgClass(variant);

  if (!items.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <div
        className={`text-small font-semibold uppercase tracking-wide ${accentTextClass}`}
      >
        {title}
      </div>
      <ol className="flex flex-col gap-2">
        {items.map((item, index) => (
          <li
            key={`${title}-${index}`}
            className={`flex gap-2 rounded-lg px-4 py-3 text-small leading-5 text-primaryGray-1 ${cardBgClass}`}
          >
            <span
              className={`shrink-0 ${
                isAccented ? `${accentTextClass}` : ""
              }`}
            >
              {index + 1}.
            </span>
            <span className="min-w-0">{item.text}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default InsightSection;
